import { setTheme } from './theme.js';
export { getTheme, setTheme } from './theme.js';
export { themes } from './themes/index.js';
import './themes/light-classic/index.js';
import './themes/dark-classic/index.js';
import './themes/dark/index.js';
import './themes/light/index.js';

setTheme("light-classic");
//# sourceMappingURL=index.js.map
